import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";

import { fetchResultFolders } from "../api/fetchJobResults";
import { JOB_RESULTS_REFRESH_MS, RESULT_KIND, type ResultKind } from "../model/constants";

const useResultKindFolders = (kind: ResultKind, configId: number | undefined, shouldRefresh: boolean) => {
  const { projectId } = useParams();
  const enabled = Boolean(projectId) && configId != null;
  return useQuery(
    ["transientJobResults", kind, projectId, configId],
    () => {
      if (!projectId || configId == null) throw new Error("Missing project");
      return fetchResultFolders(projectId, configId, kind);
    },
    {
      cacheTime: shouldRefresh ? 0 : 30 * 60 * 1000,
      enabled,
      refetchInterval: shouldRefresh ? JOB_RESULTS_REFRESH_MS : false,
      refetchOnMount: shouldRefresh,
      refetchOnWindowFocus: shouldRefresh,
      staleTime: shouldRefresh ? 0 : Infinity,
    }
  );
};

export const useTransientJobResults = (configId: number | undefined, shouldRefresh: boolean) => {
  const { t } = useTranslation();
  const dictionaries = useResultKindFolders(RESULT_KIND.dictionary, configId, shouldRefresh);
  const hourly = useResultKindFolders(RESULT_KIND.hourly, configId, shouldRefresh);

  return {
    dictionaries: dictionaries.data ?? [],
    error:
      dictionaries.isError || hourly.isError ? t("Execution.transient.jobDetails.resultsFailed") : null,
    hourly: hourly.data ?? [],
    isLoading: dictionaries.isLoading && hourly.isLoading,
  };
};
